export const translations = {
  CLOSE_MODAL: {
    en: 'Close dialog',
    sv: 'Stäng dialogrutan',
    da: 'Luk dialogboks',
    fi: 'Sulje valintaikkuna',
    no: 'Lukk dialogboksen',
  },
};

export type PnTranslations = keyof typeof translations;
